/**
 *
 * Asynchronously loads the component for SupportTicket
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const SupportTicket = lazyLoad(
  () => import('./index'),
  module => module.SupportTicket,
);
